export default "__VITE_ASSET__0Li0fCRp__"